exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".child-happy-section{padding-top:10px;padding-bottom:40px}dl.dl-horizontal,.payment-details{margin:30px 0;font-size:15pt;font-weight:300}dl.dl-horizontal dt,.payment-details dt{width:210px;font-weight:300;text-align:left}dl.dl-horizontal dd,.payment-details dd{font-weight:700;margin-left:215px}@media screen and (max-width: 767px){dl.dl-horizontal,.payment-details{margin:30px 0;text-align:left;font-size:15pt;font-weight:300}dl.dl-horizontal dt,.payment-details dt{width:auto}dl.dl-horizontal dd,.payment-details dd{margin-left:10px}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Containers/ThankYou.scss
// module id = 1070
// module chunks = 0